import { functions } from "common/config/Firebase";
import findClientByTask from "./sign/findClientByTask";

const sendRecepcionByEmailUseCase = async (taskData) => {
  if (!taskData?.dni) {
    throw new Error("Esta reparación no tiene cliente asignado");
  }

  // 1. Buscar datos del cliente
  const clientData = await findClientByTask(taskData.dni);
  const to = clientData?.mail || taskData.mail;

  if (!to) {
    throw new Error("Este cliente no tiene email configurado");
  }

  // 2. Preparar la llamada a la Cloud Function
  const sendDocumentEmail = functions.httpsCallable("sendDocumentEmail");

  const payload = {
    to,
    type: "recepcion",
    pdfUrl: null,             // NO hay adjunto
    filename: null,           // NO necesitamos PDF
    meta: {
      repairNumber: taskData.reference,
      deviceName: taskData.deviceName,
      serialNumber: taskData.imei || taskData.serialNumber || "",
    },
  };

  try {
    await sendDocumentEmail(payload);
    console.log("Email de recepción enviado correctamente✅");
  } catch (err) {
    console.error("❌ Error enviando email de recepción:", err);
  }
};

export default sendRecepcionByEmailUseCase;